import { useRef, useState } from 'react';
import type { CollectCommentDialogPropsT } from './index';
type ShowDialogPropsT = {
  primaryButtonText: string;
  onSubmit?: (comment: string) => void;
  onCancel?: () => void;
};
type UseCollectCommentDialogReturnT = {
  showDialog: (props: ShowDialogPropsT) => void;
  dialogProps: CollectCommentDialogPropsT;
};
export function useCollectCommentDialog(): UseCollectCommentDialogReturnT {
  const [dialogProps, setDialogProps] = useState<CollectCommentDialogPropsT>({
    isOpen: false
  });
  const onSubmitRef = useRef<ShowDialogPropsT['onSubmit']>();
  const onCancelRef = useRef<ShowDialogPropsT['onCancel']>();
  const showDialog = ({
    primaryButtonText,
    onSubmit,
    onCancel
  }: ShowDialogPropsT) => {
    onSubmitRef.current = onSubmit;
    onCancelRef.current = onCancel;
    setDialogProps({
      isOpen: true,
      primaryButtonText,
      onSubmit: handleSubmit,
      onCancel: handleCancel
    });
  };
  const handleSubmit = (comment: string) => {
    setDialogProps({
      isOpen: false
    });
    onSubmitRef.current?.(comment);
  };
  const handleCancel = () => {
    setDialogProps({
      isOpen: false
    });
    onCancelRef.current?.();
  };
  return {
    showDialog,
    dialogProps
  };
}